import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelLandingPagesIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 32 32"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.25586 7.21875C2.25586 6.80454 2.59165 6.46875 3.00586 6.46875H30C30.4142 6.46875 30.75 6.80454 30.75 7.21875C30.75 7.63296 30.4142 7.96875 30 7.96875H3.00586C2.59165 7.96875 2.25586 7.63296 2.25586 7.21875Z"
          fill="#1E1E1E"
        />
        <path
          d="M30 8V26.9225C30 31.0466 30 29.8336 27.5652 29.8336C25.1304 29.8336 4.43478 29.8336 4.43478 29.8336C3.78904 29.8336 3.16974 29.5269 2.71314 28.9809C2.25652 28.4349 2 27.6945 2 26.9225V8H30Z"
          fill="#66E1FF"
        />
        <path
          d="M3.99446 30H5.15789L22 8H2V27.0667C2 27.863 2 30 2 30C2 30 3.45027 30 3.99446 30Z"
          fill="#C2F3FF"
        />
        <path
          d="M10.3184 12.3906H22.7444V24.8167H10.3184V12.3906Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.56836 12.3906C9.56836 11.9764 9.90415 11.6406 10.3184 11.6406H22.7444C23.1586 11.6406 23.4944 11.9764 23.4944 12.3906V24.8167C23.4944 25.2309 23.1586 25.5667 22.7444 25.5667H10.3184C9.90415 25.5667 9.56836 25.2309 9.56836 24.8167V12.3906ZM11.0684 13.1406V24.0667H21.9944V13.1406H11.0684Z"
          fill="#1E1E1E"
        />
        <path
          d="M10.5 24.498L16.5314 17.5664L22.5 24.498"
          fill="#78EB7B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5334 16.8164C16.751 16.817 16.9577 16.9121 17.0997 17.077L23.0684 24.0087C23.3386 24.3226 23.3033 24.7961 22.9894 25.0664C22.6755 25.3367 22.2019 25.3013 21.9317 24.9874L16.5284 18.7124L11.0658 24.9904C10.7939 25.3028 10.3202 25.3357 10.0077 25.0638C9.69522 24.7919 9.66232 24.3182 9.93421 24.0057L15.9656 17.0741C16.1085 16.9099 16.3157 16.8158 16.5334 16.8164Z"
          fill="#1E1E1E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.03619 2.12051C2.5469 1.57052 3.25196 1.25 4 1.25H28C28.748 1.25 29.4531 1.57052 29.9638 2.12051C30.4728 2.66862 30.75 3.4009 30.75 4.15385V28.9645C30.75 29.9506 29.9506 30.75 28.9645 30.75H4C3.25196 30.75 2.54689 30.4295 2.03619 29.8795C1.52723 29.3314 1.25 28.5991 1.25 27.8462V4.15385C1.25 3.4009 1.52723 2.66862 2.03619 2.12051ZM4 2.75C3.68717 2.75 3.37482 2.88332 3.13538 3.14119C2.8942 3.40092 2.75 3.76433 2.75 4.15385V27.8462C2.75 28.2357 2.8942 28.5991 3.13538 28.8588C3.37483 29.1167 3.68717 29.25 4 29.25H28.9645C29.1222 29.25 29.25 29.1222 29.25 28.9645V4.15385C29.25 3.76432 29.1058 3.40092 28.8646 3.14119C28.6252 2.88333 28.3128 2.75 28 2.75H4Z"
          fill="#1E1E1E"
        />
      </SvgIcon>
    );
  })
);
